import { useEffect, useState } from 'react';
import { Hero, Services, Whatwedo, Tools, Plans, Whorwe, Contact, Footer } from "../Sections"
import Portfolio from "../Sections/Portfolio/Portfolio"
import { Accessibility, Bubbles, HelpRouter, Navbar } from "../Components"
import BottomCircleMenu from "../Components/BottomCircleMenu/BottomCircleMenu"
import { ilWspLink, uaeWspLink } from "../utils/links";

const HELP_SEEN_KEY = 'qb-help-seen';
const HELP_DELAY_MS = 7000;

const Home = ({ phone, lng, font, dir, txtAlign, cur }) => {
    const [helpOpen, setHelpOpen] = useState(false);

    const metaDescription = lng.metaDescription;
    const title = lng.title;
    let wspLink = cur === "$" ? uaeWspLink : ilWspLink

    useEffect(() => {
        let alreadySeen = false;
        try {
            alreadySeen = Boolean(sessionStorage.getItem(HELP_SEEN_KEY));
        } catch (_) {
            alreadySeen = false;
        }
        if (alreadySeen) return undefined;

        const timer = window.setTimeout(() => {
            setHelpOpen(true);
        }, HELP_DELAY_MS);

        return () => window.clearTimeout(timer);
    }, []);

    const closeHelp = () => {
        setHelpOpen(false);
        try {
            sessionStorage.setItem(HELP_SEEN_KEY, '1');
        } catch (_) {
            /* ignore */
        }
    };

    return (
        <div className={`Home ${font}`}>
            <meta name="description" content={metaDescription} />
            <title>{title}</title>
            <Bubbles />
            <Accessibility language={lng} />
            <BottomCircleMenu
                phone={phone}
                lng={lng}
                font={font}
                onOpenHelp={() => setHelpOpen(true)}
            />
            <Navbar language={lng} txtAlign={txtAlign} cur={cur} />
            <Hero language={lng} wspLink={wspLink} />
            <Services language={lng} dir={dir} />
            <Whatwedo language={lng} dir={dir}/>
            <Tools language={lng} txtAlign={txtAlign} />
            <Plans language={lng} txtAlign={txtAlign} lngCode={font} dir={dir} cur={cur} wspLink={wspLink} />
            <Portfolio language={lng} dir={dir} font={font} />
            <Whorwe language={lng} />
            <Contact language={lng} cur={cur} txtAlign={txtAlign} dir={dir} />
            <Footer language={lng} cur={cur} />

            <HelpRouter
                open={helpOpen}
                onClose={closeHelp}
                copy={lng.helpRouter}
                font={font}
                dir={dir}
                txtAlign={txtAlign}
            />
        </div>
    )
}

export default Home
